import { FC } from 'react';
import { createPortal } from 'react-dom';

import { Capacitor } from '@capacitor/core';

import Image from './Splash.svg?react';

import styles from './Splash.module.scss';

export const Splash: FC = () => {
  if (Capacitor.isNativePlatform()) {
    return null;
  }

  return createPortal(
    <div className={styles.root}>
      <Image width={334} height={419} />
    </div>,
    document.body
  );
};
